export const getDomainName = () => {
    const domainMatch = location.hostname.match(/\.[^.]*?(\.\w{1,3})?\.\w+$/);
    return (domainMatch && domainMatch.length ? domainMatch[0] : location.hostname).replace(
        /^\./,
        ""
    );
};
